import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Card, Checkbox, message } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { API_BASE_URL, API_ENDPOINTS } from '../../api/config';
import './Login.css';

const REMEMBERED_EMAIL_KEY = 'lingbi-admin-remembered-email';

const Login: React.FC = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [rememberPassword, setRememberPassword] = useState(() => Boolean(localStorage.getItem(REMEMBERED_EMAIL_KEY)));

  useEffect(() => {
    const email = localStorage.getItem(REMEMBERED_EMAIL_KEY);
    if (email) form.setFieldsValue({ email });
  }, [form]);

  // 登录
  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.system_app.loginByPassword}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: values.email,
          password: values.password,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        if (rememberPassword) {
          localStorage.setItem(REMEMBERED_EMAIL_KEY, values.email.trim());
        } else {
          localStorage.removeItem(REMEMBERED_EMAIL_KEY);
        }
        // 保存 token 和用户信息
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        
        message.success(data.message || '登录成功');
        // 强制刷新页面以更新路由状态
        window.location.href = '/dashboard';
      } else {
        message.error(data.detail || '登录失败');
      }
    } catch (error) {
      message.error('网络错误，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Card className="login-card" bordered={false}>
        <div className="login-header">
          <h1>灵笔管理后台</h1>
        </div>
        <Form
          form={form}
          name="login"
          onFinish={onFinish}
          autoComplete="on"
          size="large"
        >
          <Form.Item
            name="email"
            rules={[
              { required: true, message: '请输入邮箱' },
              { type: 'email', message: '请输入正确的邮箱格式' }
            ]}
          >
            <Input prefix={<MailOutlined />} placeholder="邮箱" autoComplete="username" />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: '请输入密码' },
              { min: 6, message: '密码至少6位' }
            ]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="密码" autoComplete="current-password" />
          </Form.Item>

          <Form.Item className="login-remember-item">
            <Checkbox checked={rememberPassword} onChange={(event) => setRememberPassword(event.target.checked)} title="密码由浏览器安全保存">
              记住密码
            </Checkbox>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading}>
              登录
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
